import React from "react"
import { useStats, usePoweredBy } from "react-instantsearch"
import AlgoliaIcon from "../svg/brands/AlgoliaIcon"
import { twMerge } from "tailwind-merge"

//powered by algolia
function CustomPoweredBy() {
  const { url } = usePoweredBy()
  return (
    <>
      <a
        className="font-extralight"
        href={url}
        target="_blank"
        rel="noreferrer"
      >
        Powered by <AlgoliaIcon className="ml-0 inline-block h-3 w-auto" />
      </a>
    </>
  )
}

function CustomStats() {
  const { processingTimeMS, nbHits } = useStats()

  return (
    <>
      <span className="ml-4 inline-flex grow items-center justify-between text-xs text-gray-300">
        <span>
          ({nbHits} results in {processingTimeMS}ms)
        </span>
        <span>
          <CustomPoweredBy />
        </span>
      </span>
    </>
  )
}

//p tag for no search results
const Ep = props => {
  return (
    <p
      className={twMerge([
        "text-center text-xs italic text-slate-500",
        props.className,
      ])}
    >
      {props.children}
    </p>
  )
}

//heading for search results in hit components (will contains Stats components)
const H2 = props => {
  return (
    <h2
      className={twMerge([
        "-mx-4 mb-1.5 flex items-baseline bg-slate-800 px-4 py-1.5 leading-none",
        props.className,
      ])}
    >
      <span className="inline-flex shrink text-base font-bold text-white">
        {props.text}
      </span>
      {props.children}
    </h2>
  )
}

export { Ep, CustomStats, H2 }
